// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, is, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants";

const isOAuthAuthorizationRequestErrorCode = anyOf(
  is(sharedConstants.OAUTH.API_ERRORS.INVALID_CLIENT),
  is(sharedConstants.OAUTH.API_ERRORS.INVALID_REDIRECT_URI),
  is(sharedConstants.OAUTH.API_ERRORS.UNSUPPORTED_RESPONSE_TYPE),
  is(sharedConstants.OAUTH.API_ERRORS.INVALID_SCOPE),
  is(sharedConstants.OAUTH.API_ERRORS.MCP_REDIRECT_URI_NOT_ALLOWED),
  is(sharedConstants.OAUTH.API_ERRORS.MCP_PERMISSION_DENIED),
  is(sharedConstants.OAUTH.API_ERRORS.MCP_SERVER_DISABLED),
  is(sharedConstants.OAUTH.API_ERRORS.PARTNER_APP_BLOCKED),
  is(sharedConstants.OAUTH.API_ERRORS.ERROR)
);

const isOAuthAuthorizationApplication = objectOf({
  name: string,
  logo_url: anyOf(string, is(null)),
  uid: string,
  redirect_uri: string,
});

const isOAuthAuthorizationPermissionValidation = objectOf({
  missing_permissions: arrayOf(number),
  has_at_least_one_permission: boolean,
  approved_scopes: arrayOf(string),
  permissionless_scopes: arrayOf(string),
  missing_scopes: arrayOf(string),
});

export const isOAuthAuthorizationRequestValidationResult = anyOf(
  objectOf({
    valid: is(true),
    error_code: is(null),
    application: isOAuthAuthorizationApplication,
    effective_scopes: arrayOf(string),
    dropped_scopes: arrayOf(string),
    permissions: isOAuthAuthorizationPermissionValidation,
  }),
  objectOf({
    valid: is(false),
    error_code: isOAuthAuthorizationRequestErrorCode,
    application: is(null),
  })
);
